export class UploadProgress {
  public readonly bytesWritten: number
  public readonly totalBytes: number

  constructor(bytesWritten: number, totalBytes: number) {
    this.bytesWritten = bytesWritten
    this.totalBytes = totalBytes
  }

  get percent(): number {
    if (this.totalBytes === 0) {
      return 0
    }
    return Math.round((this.bytesWritten / this.totalBytes) * 100)
  }

  public static empty = new UploadProgress(0, 0)
}

export type FileProgress = {
  total: number
  uploaded: number
}
